<template>
  <sdx-header
      id="header"
      v-if="loggedIn"
      :navigation="loggedInComputed.navigation"
      :slots="loggedInComputed.slots"
      :index="headerIndex"
      @sdxnavigate="(event) => navigate(event.detail.item.href, event)"
  >
    <!-- eslint-disable-next-line vue/no-deprecated-slot-attribute -->
    <div slot="logout" class="padding-2">
      <hr class="margin-top-0"/>
      <ul class="margin-top-0">
        <li v-if="envService.featureToggleBillingProfile4User()">
          <a href="/billing/profiles/view/user" class="link">
            <sdx-icon icon-name="icon-coins"/>
            Billing Profiles
          </a>
        </li>
        <li>
          <a href="/subscription/details" class="link">
            <sdx-icon icon-name="icon-api"/>
            Subscription Details
          </a>
        </li>
        <li>
          <a href="/user" class="link">
            <sdx-icon icon-name="icon-account"/>
            User Information
          </a>
        </li>
        <li class="margin-top-2">
          <a href="/logout" class="link">
            <sdx-icon icon-name="icon-gateway"/>
            Logout
          </a>
        </li>
      </ul>
    </div>
  </sdx-header>

  <sdx-header
      id="header"
      v-if="!loggedIn"
      :navigation="loggedOutComputed.navigation"
      :slots="loggedOutComputed.slots"
      :index="headerIndex"
  >

  </sdx-header>

</template>

<script>
import userService from '@/services/user.service';
import {getCurrentLanguage} from "@/i18n/i18n";
import envService from "@/services/env.service";

export default {
  data() {
    return {
      loggedIn: false,
      headerIndex: {
        label: 'Home',
        href: '/home'
      },
    };
  },
  created() {
  },
  mounted() {
    this.loggedIn = this.isLoggedIn();
    window.vueWrapper = this;
  },
  methods: {
    isLoggedIn() {
      return userService.isLoggedIn();
    },
    getUserName() {
      let user = userService.getLoggedInUser();
      return (user && user.name) || '';
    }
  },
  computed: {
    envService() {
      return envService
    },
    userService() {
      return userService
    },
    currentLanguage() {
      return getCurrentLanguage().toUpperCase()
    },
    loggedInComputed() {
      return {
        slots: [
          {
            label: this.getUserName(),
            showLabelOnDesktop: true,
            iconName: 'icon-account',
            slot: "logout",
          },
        ],
        navigation: {
          main: {
            children: [
              {
                label: 'Statistics',
                hidden: (!envService.featureToggleStats() || !userService.hasRightSms()) && !userService.isAtLeastAdminWithoutFmg(),
                children: [
                  {
                    label: 'by Month',
                    href: '/statistics',
                    hidden: !envService.featureToggleStatsOld(),
                  },
                  {
                    label: 'by Months',
                    href: '/statistics?version=months',
                  },
                  {
                    label: 'by Days',
                    href: '/statistics?version=days',
                    hidden: !envService.featureToggleStatsNew(),
                  },
                  {
                    label: 'by Country',
                    href: '/statistics/country'
                  },
                  {
                    label: 'by CostLimit Period',
                    href: '/statistics/costlimit',
                    hidden: !userService.isAtLeastAdminWithoutFmg(),
                  },
                  {
                    label: 'by State',
                    href: '/statistics?version=hours',
                    hidden: !userService.isAtLeastAdminWithoutFmg(),
                  }
                ]
              },
              {
                label: 'Outbox',
                href: '/outbox',
                hidden: !envService.featureToggleSmsOutbox() || !userService.hasRightSms(),

              },
              {
                label: 'Inbox',
                href: '/inbox',
                hidden: !envService.featureToggleSmsInbox() || !userService.hasRightReceiveSms(),
              },
              {
                label: 'Campaigns',
                hidden: !(envService.featureToggleCampaign() || envService.featureToggleQuickGuide()) || !userService.hasRightCampaignManager(),
                children: [
                  {
                    label: 'Create',
                    href: '/campaigns/create',
                    hidden: !userService.hasRightCampaignManager(),
                  },
                  {
                    label: 'Overview',
                    href: '/campaigns',
                    hidden: !userService.hasRightCampaignManager(),
                  },
                  {
                    label: 'QuickGuide',
                    href: '/campaigns/quickguide',
                    hidden: !envService.featureToggleQuickGuide(),
                  }
                ]
              },
              {
                label: 'E-Mail',
                href: '/outbox/email',
                hidden: !envService.featureToggleEmailOutbox() || !userService.hasRightEmail(),
              },
              {
                label: 'Tools',
                children: [
                  {
                    label: 'Unicode Detector',
                    href: '/unicode-detector',
                    hidden: !envService.featureToggleUnicodeDetector(),
                  },
                  {
                    label: 'Send SMS',
                    href: '/sendsms',
                    hidden: !envService.featureToggleSendSms() || !userService.hasRightSendSms(),
                  }
                ]
              },
              {
                label: 'API Products',
                href: '/api-products',
              }, {
                label: 'Configuration',
                hidden: !userService.hasRightSendSms(),
                children: [
                  {
                    label: 'Allow List',
                    href: '/prefix/allowlist',
                    hidden: (!envService.featureToggleAllowList() || !userService.hasRightSendSms()) && !userService.isAtLeastAdminWithoutFmg(),
                  },
                  {
                    label: 'Cost Limit',
                    href: '/cost/limit',

                    hidden: (!envService.featureToggleCostLimit() || !userService.hasRightSendSms()) && !userService.isAtLeastAdminWithoutFmg(),
                  },
                ]
              },
              {
                label: 'Help',
                hidden: !envService.featureToggleQuickGuide(),
                children: [
                  {
                    label: 'QuickGuide Campaigns',
                    href: '/campaigns/quickguide'
                  },
                  {
                    label: 'QuickGuide Receive SMS',
                    href: '/inbox/quickguide'
                  },
                  {
                    label: 'Login',
                    href: 'https://digital.swisscom.com/login-help-center'
                  },
                  {
                    label: 'OAuth',
                    href: 'https://digital.swisscom.com/resources/use-your-api-keys/oaut-introduction'
                  }
                ]
              },
            ],
          },
          secondary: {
            label: 'Contact & Language',
            children: [
              {
                label: 'Admin',
                hidden: !userService.isAtLeastAdminWithoutFmg() && !userService.hasRightBilling(),
                children: [
                  {
                    label: 'Activate Browser Debug Logging',
                    href: '/home?logging=debug',
                    hidden: !userService.isAtLeastAdminWithoutFmg(),
                  },
                  {
                    label: 'Activate Feature ...',
                    href: '/home?feature=',
                    hidden: !userService.isAtLeastAdminWithoutFmg(),
                  },
                  {
                    label: 'Audit Logs',
                    href: '/audit/logs',
                    hidden: !userService.isAtLeastAdminWithoutFmg(),
                  },
                  // Placeholder entry for the upcoming dedicated overall statistics screen.
                  {
                    label: 'Overall Statistics',
                    href: '/statistics/overall',
                    hidden: !userService.isAtLeastAdminWithoutFmg(),
                  },
                  {
                    label: 'Block List',
                    href: '/prefix/blocked',
                    hidden: !userService.isAtLeastAdminWithoutFmg() || !envService.featureToggleDenyList(),
                  },
                  {
                    label: 'Billing Profiles',
                    href: '/billing/profiles',
                    hidden: !envService.featureToggleBillingProfile() || !userService.hasRightBilling(),
                  },
                  {
                    label: 'Billing Run Statistic',
                    href: '/billing/run/statistic',
                    hidden: !userService.isAtLeastAdminWithoutFmg(),
                  },
                  {
                    label: 'Billing Run Status',
                    href: '/billing/run/status',
                    hidden: !userService.isAtLeastAdminWithoutFmg(),
                  },
                  {
                    label: 'Rules',
                    href: '/rules',
                    hidden: !userService.isAtLeastAdminWithoutFmg(),
                  },
                  {
                    label: 'Actual CostLimits',
                    href: '/cost/limits',
                    hidden: !userService.isAtLeastAdminWithoutFmg(),
                  },
                ]
              }
            ]
          },
          tertiary: {
            label: 'Contact & Language',
            children: [
              {
                label: 'Contact',
                href: '/contact',
              },
              {
                label: this.currentLanguage,
                hidden: true,
                children: [
                  {
                    label: 'EN',
                    href: 'javascript:this.vueWrapper.setLanguage(\'en\');document.getElementById(\'app\').click();location.reload();',
                  },
                  {
                    label: 'DE',
                    href: 'javascript:this.vueWrapper.setLanguage(\'de\');document.getElementById(\'app\').click();location.reload();',
                  },
                ],
              },
            ],
          },
        },
      };
    },
    loggedOutComputed() {
      return {
        slots: [
          {
            label: 'Login',
            href: '/login',
            iconName: 'icon-account',
            hidden: !envService.featureToggleLogin()
          }
        ],
        navigation: {
          main: {
            label: 'Navigation',
            children: [
              {
                label: 'API Products',
                href: '/',
              },
              {
                label: 'Tools',
                children: [
                  {
                    label: 'Unicode Detector',
                    href: '/unicode-detector',
                    hidden: !envService.featureToggleUnicodeDetector(),
                  },
                ]
              },
              {
                label: 'Help',
                hidden: !envService.featureToggleQuickGuide(),
                children: [
                  {
                    label: 'QuickGuide Campaigns',
                    hidden: !envService.featureToggleCampaign(),
                    href: '/campaigns/quickguide'
                  },
                  {
                    label: 'QuickGuide Receive SMS',
                    href: '/inbox/quickguide'
                  },
                  {
                    label: 'Login',
                    href: 'https://digital.swisscom.com/login-help-center'
                  },
                  {
                    label: 'OAuth',
                    href: 'https://digital.swisscom.com/resources/use-your-api-keys/oaut-introduction'
                  }
                ]
              }
            ],
          },
          tertiary: {
            label: 'Language',
            children: [
              {
                label: this.currentLanguage,
                hidden: true,
                children: [
                  {
                    label: 'EN',
                    href: 'javascript:this.vueWrapper.setLanguage(\'en\');document.getElementById(\'app\').click();location.reload();',
                  },
                  {
                    label: 'DE',
                    href: 'javascript:this.vueWrapper.setLanguage(\'de\');document.getElementById(\'app\').click();location.reload();',
                  },
                ],
              }
            ],
          },
        },
      };
    },
  },
};
</script>

<style scoped>

</style>
